export default "__VITE_ASSET__955a07d2__"